import { useState } from 'react'

import { SelectOption } from 'components/Select'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { fromDTO } from './api/mapper'
import { GET_DOMAIN_BIDDERS_FOR_SELECT } from './api/query'
import { Data, DomainBidderSliceDTO, Variables } from './api/types'
import { DomainBidderOption, Props, UseGetDomainBiddersForSelect } from './types'

export const useGetDomainBiddersForSelect = ({
  workspaceBidderId,
}: Props): UseGetDomainBiddersForSelect => {
  const [options, setOptions] = useState<SelectOption<DomainBidderOption>[]>([])

  const { isFetching } = useQuery<Variables, Data>({
    onCompleted: async ({ domainBidders: { nodes } }): Promise<void> => {
      if (nodes && nodes.length > 0) {
        setOptions(nodes.map((node: DomainBidderSliceDTO) => fromDTO(node)))
      }
    },
    query: GET_DOMAIN_BIDDERS_FOR_SELECT,
    variables: {
      workspaceBidderId,
    },
  })

  return {
    loading: isFetching,
    options,
  }
}
